
<template>
    <div class="d-flex flex-column flex-column-fluid mb-10 ">
        <setting-tool-bar :breadcrumb="breadcrumb"/>
        <div id="kt_app_content" class="app-content  flex-column-fluid ">
            <div id="kt_app_content_container" class="app-container  container-fluid " style="margin-top: 30px!important;">
                <div class="row g-7">
                    <div class="col-lg-3 col-xl-3 col-12 mt-30">
                        <div class="card card-flush">
                        <div class="card-body">
                            <ul class="nav nav-tabs nav-pills nav-fill border-0 flex-column mb-3 mb-md-0 fs-6">
                            <li v-for="(item, index) in menuItems" :key="index" class="nav-item me-0 mt-4">
                                <router-link class="nav-link btn btn-light btn-text-gray-600 btn-icon-gray-600 "  v-if="$can(item.permission)"
                                            :class="[
                            {'active btn-primary': $route.name == item.routeName},
                            {'active btn-primary': item.childRouteName && item.childRouteName.length && item?.childRouteName.includes($route.name)},
                        ]"
                                            :to="{ name: item.routeName }">
                                <div class="d-flex align-items-center justify-content-start ">
                                    <i :class="item.icon" class="m-1" ></i>
                                    <span >{{ $t(item.title) }}</span>
                                </div>
                                </router-link>
                            </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-9 col-xl-9 col-12">
                        <div v-if="$route.name == 'settings-new'" class="card card-flush h-lg-100" id="kt_contacts_main">
                            <div class="card-body p-0">
                                <div class="card-px text-center py-20 my-10">
                                    <h2 class="fs-2x fw-bolder mb-10">Welcome to the Contacts App</h2>
                                    <p class="text-gray-400 fs-4 fw-bold mb-10">It's time to expand our contacts.
                                        <br />Kickstart your contacts growth by adding a your next contact.</p>
                                    <a href="../../demo1/dist/apps/contacts/add-contact.html" class="btn btn-sm  btn-primary">Add New Contact</a>
                                </div>
                                <div class="text-center px-4">
                                    <Img filename="empty.png" class="mw-100 mh-300px" alt="" />
                                </div>
                            </div>
                        </div>
                        <router-view v-else></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Img from "@/components/Img.vue";
import SettingToolBar from "./SettingToolBar.vue";
import abilities from "@/composables/abilities";
export default {
name: "BaseSettingLayout",
components: {SettingToolBar},
data() {
    return {
    breadcrumb:  [
        {routeName:"settings", name:"navigation.setting"},
        {routeName:"settings-leave-openDays", name:"settings.setting_leaves", permission: [], routePermission: ''},
        {routeName:"rh-settings-payslips-pensions", name:"settings.payslips", permission: [], routePermission: ""},
    ],
    menuItems: [
        {
            routeName: 'rh-settings-payslips-pensions',
            title: 'settings.pension',
            icon: 'bi bi-circle-square',
            permission: []
        },
        {
            routeName: 'rh-settings-payslips-allowances',
            title: 'settings.allowances',
            icon: 'bi bi-circle-square',
            permission: []
        },
        {
            routeName: 'rh-settings-payslips-others',
            title: 'settings.others',
            icon: 'bi bi-circle-square',
            permission: []
        },
        {
            routeName: 'rh-settings-payslips-taxes',
            title: 'settings.taxes',
            icon: 'bi bi-circle-square',
            permission: []
        },
    ],
    }
},
}
</script>

<style scoped>
.btn-primary i{
    color: #FFF !important;
}
</style>
